import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { PostsService } from "../post.service";
import { Post } from "../post.model";
import { mimeType } from "./mime-type.validator";

@Component({
  selector: "app-post-create",
  templateUrl: "./post-create.component.html",
  styleUrls: ["./post-create.component.css"]
})
export class PostCreateComponent implements OnInit {
  enteredTitle = "";
  enteredContent = "";
  post: Post;
  isLoading = false;
  form: FormGroup;
  imagePreview: String = new String('');
  private mode = "create";
  private postId: string;

  constructor(
    public postsService: PostsService,
    public route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.form = new FormGroup({
      title: new FormControl(null, {
        validators: [Validators.required, Validators.minLength(3)]
      }),
      content: new FormControl(null, { validators: [Validators.required] }),
      image: new FormControl(null)
    });
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      if (paramMap.has("postId")) {
        this.mode = "edit";
        this.postId = paramMap.get("postId");
        this.isLoading = true;
        console.log(this.postId, 'UUUUUUUUUUUUUUU')
        this.postsService.getPost(this.postId).subscribe(postData => {
          console.log(postData, 'LLLLLLLLLLL')
          this.imagePreview = postData['photo'].url;
          // console.log(this.imagePreview)
          this.isLoading = false;
          this.post = {
            id: postData['_id'],
            title: postData['title'],
            content: postData['content'],
            photo: {
              url: postData['photo'].url,
              filename: postData['photo'].filename
            }
          };
          console.log(this.post)
          this.form.setValue({
            title: this.post.title,
            content: this.post.content,
            image: this.post.photo
          });
        });
      } else {
        this.mode = "create";
        this.postId = null;
        this.imagePreview = ''
      }
    });
  }

  onImagePicked(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.form.patchValue({ image: file });
    this.form.get("image").updateValueAndValidity();
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  onSavePost() {
    console.log(this.form)
    if (this.form.invalid) {
      return;
    }
    this.isLoading = true;
    if (this.mode === "create") {
      this.postsService.addPost(
        this.form.value.title,
        this.form.value.content,
        this.form.value.image
      );
    }
    else {
      if ('size' in this.form.value.image) {
        this.postsService.updatePost(
          this.postId,
          this.form.value.title,
          this.form.value.content,
          this.form.value.image
        );
      }
      else {
        this.postsService.updatePost2(
          this.postId,
          this.form.value.title,
          this.form.value.content
        );
      }
    }
    // this.form.reset();
  }
}
